import { resolveVendorDirectoryApiBase } from "./clientPortalFetch.js";

function authHeaders() {
  return { "Content-Type": "application/json" };
}

function base(clientViewId) {
  return `${resolveVendorDirectoryApiBase(clientViewId)}/mantenimiento`;
}

async function parse(response, fallback) {
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || fallback);
  return body;
}

export async function getMaintenanceOverview(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/panel`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudo cargar el panel de mantenimiento.");
}

export async function listMaintenanceWorkItems(clientViewId, query = {}) {
  const params = new URLSearchParams(query);
  const response = await fetch(`${base(clientViewId)}/tareas?${params}`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudieron cargar las tareas de mantenimiento.");
}

export async function listMaintenancePolicies(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/politicas`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudieron cargar las políticas.");
}

export async function listMaintenanceFailures(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/fallos`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudieron cargar los fallos de mantenimiento.");
}

export async function requeueMaintenanceFailure(clientViewId, deadLetterId) {
  const response = await fetch(`${base(clientViewId)}/fallos/${deadLetterId}/reintentar`, {
    method: "POST",
    credentials: "include",
    headers: authHeaders(),
    body: JSON.stringify({}),
  });
  return parse(response, "No se pudo reintentar el elemento fallido.");
}

export async function runMaintenanceJob(clientViewId, jobKey, payload = {}) {
  const response = await fetch(`${base(clientViewId)}/jobs/${jobKey}/ejecutar`, {
    method: "POST",
    credentials: "include",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return parse(response, "No se pudo ejecutar el trabajo de mantenimiento.");
}
